
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
const authStore = namespace("auth");
import CardRh from "@/components/cards/ManzaCard.vue";
import MatriculaService from "@/service/v1/sigap/MatriculaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { Prop } from "vue-property-decorator";

@Options({
    name: "HistoricoNotasIndex",
    components: { CardRh, KDataTable },
})
export default class HistoricoNotasIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public matriculaId: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.refreshTable();
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new MatriculaService();
        this.config.ajax = {
            url: this.service.getApiUrl() + "/" + this.matriculaId + "/Historico",
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.dom = "<'row'<'col-xs-12'<'col-xs-12'><'col-xs-12' >>r>" + "<'row'<'col-xs-12't>>" + "<'row'<'col-lg-3'><'col-lg-6'><'col-lg-3'i>>";
        this.config.lengthMenu = [[-1], ["Todos"]];
        this.config.columns = [
            { data: "disciplina", name: "disciplina", orderable: false },
            { data: "disciplinaTipo", name: "disciplinatipo" , orderable: false},
            { data: "cargaHoraria", name: "cargahoraria" , orderable: false},
            { data: "qteFaltas", name: "qtefaltas" , orderable: false},
            { data: "nota", name: "nota" , orderable: false},
            { data: "reprovado", name: "reprovado" , orderable: false},
            { data: "situacao", name: "situacao", orderable: false },
            { data: "notaVC", name: "notavc", orderable: false },
            { data: "notaVF", name: "notavf", orderable: false },
            { data: "notaVR", name: "notavr", orderable: false },
        ];

        this.config.columnDefs = [
            {
                targets: 1,
                render: (row) => {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 3,
                render: (row, type, val) => {
                    return row + " / " + val.limiteFaltas;
                }
            },
            {
                targets: 5,
                render: (row) => {
                    return row ? "Sim" : "Nao";
                }
            },
        ];
    }
}
